var noop = function noop() {};

export default noop;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/noop.js
// module id = 214
// module chunks = 44